/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import Header from 'apps/Header'
import Footer from 'apps/Footer'
import CreateProfile from './routes/CreateProfile'
import ViewProfile from './routes/ViewProfile'
import ChangePlan from './routes/ChangePlan'
import RenewPlan from './routes/RenewPlan'
import EnrollPlan from './routes/EnrollSubscription'
import RenewAndChangePlanAccepted from './routes/RenewAndChangeSubscription/RenewAndChangeSubscription'
import ProfileSettings from './routes/ProfileSettings'
import * as styles from './Profile.scss'
import MaintenanceBanner from 'apps/MaintenanceBanner'

interface IProps {
  isUserAbleToOpenProfile: boolean,
  isUserAbleToChangePlan: boolean,
  isUserNeedsToRenewSubscription: boolean,
  isEnrollAvailable: boolean,
}

const Profile: React.FC<IProps> = ({ isUserAbleToOpenProfile, isUserAbleToChangePlan,
  isUserNeedsToRenewSubscription, isEnrollAvailable }) => (
  <React.Fragment>
    <Header page='profile' />
    <MaintenanceBanner/>
    <div className={styles.page}>
      <Switch>
        <Route path={ROUTES.profile.create} component={CreateProfile} exact />
        <Route path={ROUTES.profile.renewAndChangePlan.accepted} component={RenewAndChangePlanAccepted} exact />
        {isUserAbleToOpenProfile && [
          <Route key='view' path={ROUTES.profile.view} component={ViewProfile} exact />,
          <Route key='settings' path={ROUTES.profile.settings} component={ProfileSettings} exact />,
        ]}
        {isUserAbleToChangePlan && (
          <Route path={Object.values(ROUTES.profile.changePlan)} component={ChangePlan} exact />
        )}
        {isUserNeedsToRenewSubscription && (
          <Route path={Object.values(ROUTES.profile.renewPlan)} component={RenewPlan} exact />
        )}
        {(isEnrollAvailable || isUserNeedsToRenewSubscription) && (
          <Route path={Object.values(ROUTES.profile.enrollPlan)} component={EnrollPlan} exact />
        )}
        {isUserAbleToOpenProfile && (
          <Redirect to={ROUTES.profile.view} />
        )}
        {!isUserAbleToOpenProfile && (
          <Redirect to={ROUTES.profile.create} />
        )}
      </Switch>
      <Footer />
    </div>
  </React.Fragment>
)

export default Profile
